export const ONBOARDING_SESSION_KEY = 'bill:onboarding';
export const CHECKOUT_REFERENCE_KEY = 'bill:checkout-reference';
